// [2026-08-11] ADDED — shadcn Card.
//
// Adapted for a project WITHOUT Tailwind preflight (see src/shadcn.css): upstream shadcn assumes
// the reset has already zeroed heading margins and set `border: 0 solid`, so this file states both
// explicitly. Without that, CardTitle inherits the browser's h3 margin and the card gains a gap
// nobody can find in the CSS.
//
// `rounded-[var(--radius)]` rather than `rounded-lg`, because theme.css owns the --radius-*
// namespace and this file must not claim it.

import { cn } from '../../lib/utils.js'

function Card({ className, ...props }) {
  return (
    <div
      className={cn(
        'rounded-[var(--radius)] border border-solid border-border bg-card text-foreground',
        'shadow-[0_1px_2px_rgba(16,15,12,0.04)]',
        className,
      )}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }) {
  return <div className={cn('flex flex-col gap-1 px-5 pt-4 pb-3', className)} {...props} />
}

function CardTitle({ className, ...props }) {
  return (
    <h3
      className={cn('m-0 text-[15px] font-semibold leading-none tracking-tight', className)}
      {...props}
    />
  )
}

function CardDescription({ className, ...props }) {
  return <p className={cn('m-0 text-[12.5px] text-muted-foreground', className)} {...props} />
}

function CardContent({ className, ...props }) {
  return <div className={cn('px-5 pb-5', className)} {...props} />
}

function CardFooter({ className, ...props }) {
  return (
    <div
      className={cn('flex items-center gap-2 border-t border-solid border-border px-5 py-3',
                    className)}
      {...props}
    />
  )
}

export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle }
